import { STATE_PRIVACY_UPDATE, StatePrivacyUpdateActionType, GPC_SIGNAL_CHECK_COMPLETE, GPCSignalCheckActionType, GPCSignalStatusActionType, GPC_SIGNAL_STATUS } from '../actions/statePrivacyActions';

export interface StatePrivacy {
    refreshTargetingAPICalls: boolean;
    gpcCheckComplete: boolean;
    gpcEnabled?: boolean;
}

const initialState: StatePrivacy = {
    refreshTargetingAPICalls: false,
    gpcCheckComplete: false
};

export function statePrivacy(state: StatePrivacy = initialState, action: StatePrivacyUpdateActionType | GPCSignalCheckActionType | GPCSignalStatusActionType): StatePrivacy {
    switch (action.type) {
        case STATE_PRIVACY_UPDATE:
        {
            return {
                ...state,
                refreshTargetingAPICalls: !state?.refreshTargetingAPICalls
            };   
        }
        case GPC_SIGNAL_CHECK_COMPLETE:
        {
            return {
                ...state,
                gpcCheckComplete: true
            };   
        }
        case GPC_SIGNAL_STATUS:
        {
            return {
                ...state,
                gpcEnabled: action.payload
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}